import React, { FC } from 'react';
import { View } from 'react-native';

import { ContainerStyle } from '@interfaces/base';

export interface DashboardDrilldownBreakdownProps extends ContainerStyle {}

const DashboardDrilldownBreakdown: FC<DashboardDrilldownBreakdownProps> = ({ containerStyle }) => {
  return <View style={[{ flex: 1 }, containerStyle]} />;
};

export default DashboardDrilldownBreakdown;
